import {
  ErrorDefault,
  RequestDefault,
  ResponseDefault,
} from "../../shared/constant";
import accountConstants from "../constants/accountConstants";

const initialState: {
  newAccount: any;
  clientTypes: any[];
  category: any[];
  clients: any[];
  clientsPending: boolean;
  clientsCount: number;
  client: any;
  allClients: any;
  existedClientShare: any[];
  clientAdjustments: any[];
  noPageclientAdjustments: any;
  clientAdjustmentsResponse: any;
  error: Boolean;
  pending: Boolean;
  fulfilled: Boolean;
  clientInfoPending: Boolean;
  clientInfoSuccess: any;
  paymentWithAdjustmentSuccess: Boolean;
  paymentAdjPending: Boolean;
  clientFilterEditError: [] | null;
  clientAdjustmentsPending: Boolean;
} = {
  newAccount: null,
  clientTypes: [],
  category: [],
  clients: [],
  clientsPending: false,
  clientsCount: 0,
  client: null,
  allClients: null,
  existedClientShare: [],
  clientAdjustments: [],
  noPageclientAdjustments: [],
  clientAdjustmentsResponse: null,
  error: false,
  pending: false,
  fulfilled: false,
  clientInfoPending: false,
  clientInfoSuccess: null,
  paymentWithAdjustmentSuccess: false,
  paymentAdjPending: false,
  clientFilterEditError: null,
  clientAdjustmentsPending: false,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case accountConstants.ADD_ACCOUNT_REQ:
    case accountConstants.EDIT_CLIENT_FILTER_REQUEST:
      return {
        ...state,
        ...RequestDefault,
      };
    case accountConstants.ADD_ACCOUNT_SUCCESS:
      return {
        ...state,
        ...ResponseDefault,
        newAccount: action.payload,
      };
    case accountConstants.EDIT_CLIENT_FILTER_SUCCESS:
      return {
        ...state,
        ...ResponseDefault,
      };
    case accountConstants.EDIT_CLIENT_FILTER_FAILURE:
      return {
        ...state,
        ...ErrorDefault,
        clientFilterEditError: action.err.response?.data?.error,
      };
    case accountConstants.ADD_ACCOUNT_FAILURE:
      return {
        ...state,
        ...ErrorDefault,
      };
    case accountConstants.EDIT_CLIENT_INFO_REQUEST:
      return {
        ...state,
        clientInfoPending: true,
        clientInfoSuccess: null,
      };
    case accountConstants.EDIT_CLIENT_INFO_SUCCESS:
      return {
        ...state,
        clientInfoPending: false,
        clientInfoSuccess: action.payload,
      };
    case accountConstants.EDIT_CLIENT_INFO_FAILURE:
      return {
        ...state,
        clientInfoPending: false,
        clientInfoSuccess: null,
      };
    case accountConstants.GET_CLIENT_TYPES_SUCCESS:
      return {
        ...state,
        clientTypes: action.payload.data.results,
      };
    case accountConstants.GET_SIGNUP_CATEGORY_SUCCESS:
      return {
        ...state,
        category: action.payload.data.results,
      };
    case accountConstants.GET_CLIENTS_REQUEST:
      return {
        ...state,
        clientsPending: true,
      };
    case accountConstants.GET_CLIENTS_SUCCESS:
      return {
        ...state,
        clientsPending: false,
        clients: action.payload.data.results,
        clientsCount: action.payload.data.count,
      };
    case accountConstants.GET_CLIENTS_FAILURE:
      return {
        ...state,
        clientsPending: false,
      };
    case accountConstants.GET_ALL_CLIENTS_SUCCESS:
      return {
        ...state,
        allClients: action.payload.data,
      };
    case accountConstants.GET_SINGLE_CLIENT_SUCCESS:
      return {
        ...state,
        client: action.payload.data,
      };
    case accountConstants.GET_IS_CLIENT_SHARE_EXIST_SUCCESS:
      return {
        ...state,
        existedClientShare: action.payload.data,
      };
    case accountConstants.GET_CLIENT_ADJUSTMENT_AMOUNT_REQUEST:
      return {
        ...state,
        clientAdjustmentsPending: true,
      };
    case accountConstants.GET_CLIENT_ADJUSTMENT_AMOUNT_SUCCESS:
      return {
        ...state,
        clientAdjustmentsPending: false,
        clientAdjustments: action.payload.data.results,
        clientAdjustmentsResponse: action.payload.data,
      };
    case accountConstants.GET_CLIENT_ADJUSTMENT_AMOUNT_FAILURE:
      return {
        ...state,
        clientAdjustmentsPending: false,
      };
    case accountConstants.GET_NO_PAGE_ADJUSTMENT_AMOUNT_SUCCESS:
      return {
        ...state,
        noPageclientAdjustments: action.payload.data,
      };
    case accountConstants.PAYMENT_WITH_ADJUSTMENT_REQUEST:
      return {
        ...state,
        paymentAdjPending: true,
        paymentWithAdjustmentSuccess: false,
      };
    case accountConstants.PAYMENT_WITH_ADJUSTMENT_SUCCESS:
      return {
        ...state,
        paymentAdjPending: false,
        paymentWithAdjustmentSuccess: true,
      };
    case accountConstants.PAYMENT_WITH_ADJUSTMENT_FAILURE:
      return {
        ...state,
        paymentAdjPending: false,
        paymentWithAdjustmentSuccess: false,
      };
    case accountConstants.RESET_EXISTED_CLIENT_SHARE_CLIENT:
      return {
        ...state,
        existedClientShare: [],
      };
    case accountConstants.RESET_CLIENT_FILTER_EDIT_ERROR:
      return {
        ...state,
        clientFilterEditError: null,
      };
    case accountConstants.RESET_CLIENT:
      return {
        ...state,
        client: null,
        clientAdjustments: [],
        paymentWithAdjustmentSuccess: false,
      };
    case accountConstants.RESET_CLIENTS:
      return {
        ...state,
        clients: [],
        clientsCount: 0,
      };
    default:
      return {
        ...state,
      };
  }
};
